import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  GetParams,
  GetResponse,
  Stages,
  StagesCreate,
  StagesType,
  PostResponse,
  User,
  UserCreate,
} from '@app/shared';
import { convertGetParamsToHttpParams } from '@app/core';

@Injectable({
  providedIn: 'root',
})
export class StagesService {
  /** URLs principales relacionadas con Stagess **/
  StagesUrl = environment.coreApiBaseUrl + '/api/crmstage';
  StagesTypeUrl = environment.coreApiBaseUrl + '/api/Stages-type';
  userUrl = environment.identityApiBaseUrl + '/api/user';

  constructor(private http: HttpClient) {}

  /** Metodos de obtener/crear/actualizar/eliminar Stagess **/
  getStages(
    getParams: GetParams,
    accessToken?: string
  ): Observable<GetResponse> {
    let headers = new HttpHeaders();

    // Si el accessToken es proporcionado, agregamos el header Authorization
    if (accessToken) {
      headers = headers.set('Authorization', `Bearer ${accessToken}`);
    }

    // Realizamos la petición GET con los parámetros y, si es necesario, con el token de autorización
    return this.http.get<GetResponse>(this.StagesUrl, {
      params: convertGetParamsToHttpParams(getParams),
      headers: headers, // Pasamos los headers
    });
  }

  createStages(newStages: StagesCreate): Observable<PostResponse> {
    return this.http.post<PostResponse>(this.StagesUrl, newStages);
  }

  updateStages(stages: Stages): Observable<any> {
    return this.http.put(this.StagesUrl, stages);
  }

  deleteStages(StagessIds: number[]): Observable<any> {
    return this.http.delete(this.StagesUrl, { body: { ids: StagessIds } });
  }

  /** Metodos de obtener/crear/actualizar/eliminar StagesTypes **/
  getStagesType(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.StagesTypeUrl, {
      params: convertGetParamsToHttpParams(getParams),
    });
  }

  createStagesType(newStagesType: {
    name: string;
    isActive: boolean;
  }): Observable<PostResponse> {
    return this.http.post<PostResponse>(this.StagesTypeUrl, newStagesType);
  }

  updateStagesType(StagesType: StagesType): Observable<any> {
    return this.http.put(this.StagesTypeUrl, StagesType);
  }

  deleteStagesType(StagesTypesIds: number[]): Observable<any> {
    return this.http.delete(this.StagesTypeUrl, {
      body: { ids: StagesTypesIds },
    });
  }

  /** Metodos de obtener/crear/actualizar/eliminar User **/
  getUser(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.userUrl, {
      params: convertGetParamsToHttpParams(getParams),
    });
  }

  createUser(newUser: UserCreate): Observable<PostResponse> {
    return this.http.post<PostResponse>(this.userUrl, newUser);
  }

  updateUser(User: User): Observable<any> {
    return this.http.put(this.userUrl, User);
  }

  deleteUser(desconsolidationsTypeIds: number[]): Observable<any> {
    return this.http.delete(this.userUrl, {
      body: { ids: desconsolidationsTypeIds },
    });
  }
}
